import React, { useState } from "react";
import Accordian from "../../../../components/accordian/accordian";
import { Typography } from "@mui/material";
import { ScopeFieldStyled } from "./scope-filed.style";
import RichTextEditor from "../../../../components/rich-text-editor/rich-text-editor";

const ScopeField = ({ scope, isGeneral, handleChange, isGeneralUser }) => {
  const [expanded, setExpanded] = useState([""]);

  return (
    <ScopeFieldStyled isGeneralUser={isGeneralUser}>
      <Accordian
        name="scope"
        handleChange={setExpanded}
        expanded={expanded.includes("scope") ? "scope" : ""}
        heading={<Typography variant="h5">Project Scope</Typography>}
        body={
          <div className="field">
            <RichTextEditor
              value={scope}
              onChange={handleChange}
              placeholder="Describe the project scope here..."
              readOnly={isGeneral}
              disabled={isGeneral}
            />
          </div>
        }
        variant="purple"
        arrowPosition="right"
      />
    </ScopeFieldStyled>
  );
};

export default ScopeField;
